@if (formElement?.fieldType === FormFieldType.Address) {
    <ng-container [formGroup]="$any(controlContainer?.control)">
        <wdx-ff-address-control
            [formElement]="formElement"
            [entityId]="entityId"
        ></wdx-ff-address-control>
    </ng-container>
} @else {
    <wdx-ff-controls-mapper
        class="h-100 d-block"
        [formElement]="formElement"
        [formContext]="formContext"
        [entityId]="entityId"
        (formEvent)="formEvent.emit($event)"
    ></wdx-ff-controls-mapper>
}
